import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=2670d52f&scoped=true"
var script = {}
import style0 from "./Title.vue?vue&type=style&index=0&id=2670d52f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670d52f",
  null
  
)

export default component.exports